import { AfterViewInit } from '@angular/core';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

@Component({
  selector: 'input-text-maps',
  templateUrl: './input-text-maps.component.html',
  styleUrls: ['./input-text-maps.component.css']
})
export class InputTextMapsComponent implements OnInit, AfterViewInit {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 500;
  @Input() showIconSuccess: boolean = false;
  @Input() class: string = 'form-control';
  @Input() mapData: GoogleMapData = {};
  @Output() mapDataChange = new EventEmitter<GoogleMapData>();

  @ViewChild('inputSearch') public searchElementRef!: ElementRef;

  constructor() {

  }

  validateMapAddress(): ValidatorFn {

    return (): ValidationErrors | null => {

      if (!this.control.value)
        return null;


      if (!this.mapData.latitude) return { invalidMap: { notFound: true } };
      if (!this.mapData.longitude) return { invalidMap: { notFound: true } };
      // if (!this.mapData.place_id) return { invalidMap: { notFound: true } };
      if (!this.mapData.formatted_address) return { invalidMap: { notFound: true } };


      if (!this.mapData.administrative_area_level_1) return { invalidMap: { incomplete: true } };
      if (!this.mapData.administrative_area_level_3) return { invalidMap: { incomplete: true } };
      // if (!this.mapData.route) return { invalidMap: { incomplete: true } };
      // if (!this.mapData.street_number) return { invalidMap: { noNumber: true } };
      // if (!this.mapData.postal_code) return { invalidMap: true };
      return null;
    }
  }

  ngOnInit(): void {
    this.control.setValidators([Validators.required, this.validateMapAddress()])
  }

  ngAfterViewInit(): void {

    // Binding autocomplete to search input control
    let autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef.nativeElement, { componentRestrictions: { country: "CL" } }
    );

    autocomplete.addListener('place_changed', () => {

      //get the place result
      let place: google.maps.places.PlaceResult = autocomplete.getPlace();

      //verify result
      if (place.geometry === undefined || place.geometry === null) {
        this.mapData = {};
        this.mapDataChange.next(this.mapData);
        return;
      }

      var street_number: string = place.address_components?.filter(e => e.types.includes("street_number")).map(e => { return e.long_name })[0];
      var route: string = place.address_components?.filter(e => e.types.includes("route")).map(e => { return e.long_name })[0];

      if (place.formatted_address && (!street_number || !route)) {

        try {
          // get the first string 
          const r = place.formatted_address.split(",")[0];

          // get just numbers
          street_number = r.match(/\d/g).join("")

          // get string until number position
          route = place.formatted_address.substring(0, r.search(/\d/g))

        } catch {
          // if fail continues
        }
      }




      this.mapData = {
        latitude: place.geometry.location?.lat(),
        longitude: place.geometry.location?.lng(),
        place_id: place.place_id,
        formatted_address: place.formatted_address,
        administrative_area_level_1: place.address_components?.filter(e => e.types.includes("administrative_area_level_1")).map(e => { return e.long_name })[0],
        administrative_area_level_3: place.address_components?.filter(e => e.types.includes("administrative_area_level_3")).map(e => { return e.long_name })[0],
        street_number,
        route,
        postal_code: place.address_components?.filter(e => e.types.includes("postal_code")).map(e => { return e.long_name })[0],
      }

      this.control.setValue(place.formatted_address)

      this.mapDataChange.next(this.mapData);
    });
  }
}

